import { createContext } from 'react'

export type UltraModuleBundlingType = boolean

const UltraModuleBundlingContext = createContext<
  UltraModuleBundlingType | undefined
>(undefined)

export default UltraModuleBundlingContext
